import {
  CompletionStatuses,
  CrewTypes,
  ProjectStatuses,
  SettingTypes
} from "../constants/enums";
import {
  ContractStatuses,
  ContractSubEntities,
  ContractTabs,
  ScopeDocumentCondensedTypes
} from "../constants/contract-enums";
import {
  ContactTypesCondensed,
  PartnerSubtypes
} from "../constants/contact-enums";

export const CompletionStatusIcons = {
  [CompletionStatuses.NOT_STARTED]: "bdg-icon play",
  [CompletionStatuses.IN_PROGRESS]: "bdg-icon progress",
  [CompletionStatuses.COMPLETED]: "bdg-icon check"
};

export const ProjectIcons = {
  [ProjectStatuses.DESIGN]: "bdg-icon blueprint",
  [ProjectStatuses.ACTIVE]: "bdg-icon shovel",
  [ProjectStatuses.WARRANTY]: "bdg-icon warranty",
  [ProjectStatuses.INACTIVE]: "bdg-icon snooze"
};

export const ProjectShowIcons = {
  [ContractStatuses.ACTIVE]: "bdg-icon leaf",
  [ContractStatuses.WARRANTY]: "bdg-icon warranty",
  [ContractStatuses.CLOSED]: "bdg-icon snooze"
};

export const ContractShowIcons = {
  [ContractTabs.SCOPE]: "bdg-icon scope",
  [ContractTabs.PROCEDURES]: "bdg-icon gearset",
  [ContractTabs.CONTACTS]: "bdg-icon handshake",
  [ContractTabs.PLANS]: "bdg-icon ruler-pencil",
  [ContractTabs.PROCUREMENTS]: "bdg-icon package",
  [ContractTabs.JOB_TRACKING]: "bdg-icon checklist",
  [ContractTabs.WORK_ORDERS]: "bdg-icon hardhat-goggles",
  [ContractTabs.NOTES]: "bdg-icon notes"
};

export const ContractSubEntityIcons = {
  [ContractSubEntities.PROCUREMENT]: "bdg-icon package",
  [ContractSubEntities.WORK_ORDER]: "bdg-icon hardhat-goggles"
};

export const ContactIcons = {
  all: "bdg-icon contacts",
  [ContactTypesCondensed.CUSTOMER]: "bdg-icon couple",
  [ContactTypesCondensed.PARTNER_VENDOR]: "bdg-icon handshake",
  [ContactTypesCondensed.INTERNAL]: "bdg-icon logo"
};

export const PartnerSubtypeIcons = {
  [PartnerSubtypes.ARCHITECT]: "bdg-icon column",
  [PartnerSubtypes.BUILDER]: "bdg-icon wall",
  [PartnerSubtypes.INT_DESIGNER]: "bdg-icon tags"
};

export const CrewIcons = {
  [CrewTypes.LANDSCAPE]: "bdg-icon trees",
  [CrewTypes.MASONRY]: "bdg-icon bricks",
  [CrewTypes.LIGHTING]: "bdg-icon lightbulb",
  [CrewTypes.SUBCONTRACTOR]: "bdg-icon wheelbarrow"
};

export const SettingIcons = {
  [SettingTypes.USER]: "bdg-icon user",
  [SettingTypes.SCOPE]: "bdg-icon scope"
};

export const ScopeDocumentTypeIcons = {
  [ScopeDocumentCondensedTypes.DESIGN]: "bdg-icon design",
  [ScopeDocumentCondensedTypes.CONSTRUCTION]: "bdg-icon construction"
};
